module.exports = __webpack_public_path__ + "static/media/gul.47d8b22d.png";